<template>
    <section class="main">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class='el-icon-service'></i> 客服中心</el-breadcrumb-item>
                <el-breadcrumb-item>客服联系方式</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='联系人'>
                                <el-input v-model='queryParams.name' clearable placeholder='联系人' />
                            </el-form-item>
                            <el-form-item label='类型'>
                                <el-select v-model='queryParams.type' clearable placeholder='类型'>
                                    <el-option v-for='item in contactTypeOptions' :key='item.value' :label='item.label'
                                               :value='item.value' />
                                </el-select>
                            </el-form-item>
                            <el-form-item label='服务器'>
                                <el-select v-model='queryParams.serverType' clearable placeholder='服务器'>
                                    <el-option v-for='item in serverTypeOptions' :key='item.value' :label='item.label'
                                               :value='item.value' />
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type='primary' icon='el-icon-search' @click='handleQuery'>搜索</el-button>
                                <el-button icon='el-icon-refresh' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='4' class='table-actions'>
                        <el-button type='primary' plain icon='el-icon-plus' @click='handleAdd'>新增</el-button>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :data='tableList' :cell-style="{ textAlign: 'center' }"
                      :header-cell-style="{ textAlign: 'center' }">
                <el-table-column label='联系人' prop='name' />
                <el-table-column label='类型'>
                    <template slot-scope='scope'>{{ getContactTypeLabel(scope.row.type) }}</template>
                </el-table-column>
                <el-table-column label='联系方式' prop='contactValue' show-overflow-tooltip />
                <el-table-column label='适用服务器'>
                    <template slot-scope='scope'>
                        <el-tag v-for='item in scope.row.serverTypes' :key='item' size='mini' class='tag-item'>
                            {{ getServerTypeLabel(item) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label='更新时间' prop='updateTime' show-overflow-tooltip />
                <el-table-column label='操作' width='160' fixed='right'>
                    <template slot-scope='scope'>
                        <el-button type='text' icon='el-icon-edit' @click='handleUpdate(scope.row)'>修改</el-button>
                        <el-button type='text' icon='el-icon-delete' @click='handleDelete(scope.row)'>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout="total, prev, pager, next"
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <el-dialog :title='title' :visible.sync='open' append-to-body width='520px' :before-close='cancel'>
                <el-form ref='form' :model='form' label-width='100px'>
                    <el-form-item label='联系人'>
                        <el-input v-model='form.name' placeholder='请输入联系人名称' />
                    </el-form-item>
                    <el-form-item label='类型'>
                        <el-select v-model='form.type' placeholder='请选择类型'>
                            <el-option v-for='item in contactTypeOptions' :key='item.value' :label='item.label'
                                       :value='item.value' />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label='contactValueLabel'>
                        <el-input v-model='form.contactValue' :placeholder='contactValuePlaceholder' />
                    </el-form-item>
                    <el-form-item label='适用服务器'>
                        <el-select v-model='form.serverTypes' multiple placeholder='请选择服务器'>
                            <el-option v-for='item in serverTypeOptions' :key='item.value' :label='item.label'
                                       :value='item.value' />
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确定</el-button>
                    <el-button @click='cancel'>取消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>
import { customerContactApi } from '@api/customer';
import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';

export default {
    name: 'Customer',
    data() {
        return {
            loading: false,
            open: false,
            updateStatus: false,
            title: '',
            tableList: [],
            queryParams: {
                pageNum: 1,
                pageSize: 15,
                total: 0,
                name: undefined,
                type: undefined,
                serverType: undefined
            },
            form: {},
            contactTypeOptions: [
                { label: 'QQ', value: 'QQ' },
                { label: '企业微信', value: 'WECHAT_WORK' },
                { label: '邮箱', value: 'EMAIL' }
            ],
            serverTypeOptions: [
                { label: '中国', value: 'MAINLAND' },
                { label: '海外', value: 'OVERSEAS' }
            ]
        };
    },
    computed: {
        contactValueLabel() {
            if (this.form.type === 'QQ') {
                return 'QQ号';
            }
            if (this.form.type === 'WECHAT_WORK') {
                return '企业微信链接';
            }
            if (this.form.type === 'EMAIL') {
                return '邮箱';
            }
            return '联系方式';
        },
        contactValuePlaceholder() {
            if (this.form.type === 'WECHAT_WORK') {
                return '请输入可唤起微信客服的链接';
            }
            return '请输入联系方式';
        }
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.loading = true;
            customerContactApi.query(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.tableList = response.data.result || [];
                    this.queryParams.total = response.data.total;
                    this.queryParams.pageNum = response.data.pageNum;
                }
                this.loading = false;
            });
        },
        submitForm() {
            if (!this.form.name) {
                message.error('请输入联系人');
                return;
            }
            if (!this.form.type) {
                message.error('请选择类型');
                return;
            }
            if (!this.form.contactValue) {
                message.error('请输入联系方式');
                return;
            }
            if (!this.form.serverTypes || this.form.serverTypes.length === 0) {
                message.error('请选择适用服务器');
                return;
            }
            const request = this.updateStatus ? customerContactApi.update : customerContactApi.insert;
            request(this.form).then(response => {
                if (response.code === 200) {
                    message.success(this.updateStatus ? '修改成功' : '新增成功');
                    this.open = false;
                    this.getList();
                }
            });
        },
        handleAdd() {
            this.title = '新增客服联系方式';
            this.updateStatus = false;
            this.form = { type: 'QQ', serverTypes: ['MAINLAND'] };
            this.open = true;
        },
        handleUpdate(row) {
            this.title = '修改客服联系方式';
            this.updateStatus = true;
            this.form = deepCopy(row);
            this.open = true;
        },
        handleDelete(row) {
            this.$confirm(`确认删除"${row.name}"吗？`, '提示', { type: 'warning' }).then(() => {
                customerContactApi.deleteData({ id: row.id }).then(response => {
                    if (response.code === 200) {
                        message.success('删除成功');
                        this.getList();
                    }
                });
            });
        },
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 15,
                total: 0,
                name: undefined,
                type: undefined,
                serverType: undefined
            };
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        cancel() {
            this.open = false;
        },
        getContactTypeLabel(type) {
            const option = this.contactTypeOptions.find(item => item.value === type);
            return option ? option.label : type;
        },
        getServerTypeLabel(type) {
            const option = this.serverTypeOptions.find(item => item.value === type);
            return option ? option.label : type;
        }
    }
};
</script>

<style scoped>
.table-actions {
    text-align: right;
}

.tag-item {
    margin-right: 6px;
}
</style>
